module.exports = __webpack_public_path__ + "img/Group 430.87ce04a5.png";